<template>
  <div
    style="position: relative;"
    @mouseover="mouseOver"
    @mouseleave="mouseLeave"
  >
    <div class="close" @click.stop="removeItem(item)">
    <IconClose
      v-if="this.active"
      :width=10
      :height=10
      :color="'#F76A20'"
    />
    </div>
    <div
      class="geodkobjekt"
      v-bind:class="{ active: active }"
    >
      <h1>{{vejkode}}</h1>
      <div class="adressering" v-bind:class="{ hidden: !adressering}">{{adressering}}</div>
      <div class="vejtype-geodk">
        <span>{{this.item.get('vejmidtetype')}}/{{this.item.get('vejkategori')}}</span>
        <span>{{this.item.get('geoDkId')}}</span>
      </div>
    </div>
  </div>

</template>

<script>
import IconClose from '@/components/common/Icon/IconClose/IconClose.vue';
export default {
  name: 'GeoDkObjektListItem',
  components: {
    IconClose,
  },
  props: {
    item: Object,
    removeItem: Function,
  },
  computed: {
    vejkode () {
      return this.item.get('vejkode') ? this.item.get('vejkode') : '(Ingen)';
    },
    adressering () {
      const adressering = this.item.get('adressering');
      if (adressering) {
        return adressering.navn + ', ' + adressering.postnr;
      }
      return '';
    },
  },
  data: function () {
    return {
      active: false,
    };
  },
  methods: {
    mouseOver () {
      this.$store.commit('highlightSelectedGeodk', {
        geoDkId: this.item.get('geoDkId'),
      });
      this.active = true;
    },
    mouseLeave () {
      this.active = false;
    },
  },
  mounted () {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'highlightSelectedGeodk') {
        const { geoDkId, scrollTo } = mutation.payload;
        if (geoDkId === this.item.get('geoDkId')) {
          this.active = true;
          if (scrollTo) {
            this.$el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
        } else {
          this.active = false;
        }
      }
    });
  },
};
</script>

<style lang="scss" scoped>
.geodkobjekt {
  background-color: #FFFFFF;
  color: rgba(0,0,0,0.8);
  font-size: 12px;
  padding: 3px;
  margin: 8px 0 0 0;
  box-shadow: 0 2px 10px 0 rgba(92,109,150,0.30);
  height: 120px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: stretch;
  padding: 0 20px 20px 20px;
  border-radius: 2px 2px 0 0;
  border: solid 1px #ffffff;
}

.active {
  border: solid 1px $selected-highlight-color;
}

h1{
  color: $selected-color;
  font-size: 24px;
  font-weight: 600;
  letter-spacing: 1.16px;
  text-align: center;
  margin-bottom: 0;
}

.active h1 {
  color: $selected-highlight-color;
}

.adressering {
  text-align: center;
  letter-spacing: -0.74px;
  font-weight: 600;
  color: #8d8d8d;
}
.vejtype-geodk{
  display: flex;
  justify-content: space-between;
  letter-spacing: -0.74px;
  color: #8d8d8d;
}

.hidden:after {
  content: '.';
  visibility: hidden;
}
.close {
  position: absolute;
  top: 0px;
  left: 5px;
}
</style>
